import React from "react";
import Navigation from "../partials/Navigation";
import HorizontalNav from "../partials/Dashboard/HorizontalNav";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import BatteryData from "../partials/MyBattery/BatteryData";

const MyBattery = () => {
  const [translation] = useTranslation("translations");
  

  return (
    <div className="main-wrapper">
      <Helmet>
        <title>{translation("battery_levels")}</title>
        <meta name="description" content="" />
      </Helmet>
      <Navigation />
      <div className="page-content-wrap">
        <HorizontalNav title={translation("battery_levels")} />
        <div className="px-3 pt-3 page-content-inner ">
          <BatteryData />
        </div>
      </div>
    </div>
  );
};
export default MyBattery;
